module.exports = __webpack_public_path__ + "img/15.db002fe9.jpg";